import { useCallback } from "react";
import { useAppDispatch, useAppSelector } from "../store/hooks";
import {
  openPanel,
  closePanel,
  toggleMinimize,
  focusPanel,
  closeAll,
} from "../store/slices/workPanelSlice";

export const useWorkPanel = () => {
  const dispatch = useAppDispatch();
  const panels = useAppSelector((state) => state.workPanel.panels);
  const focusedWorkId = useAppSelector((state) => state.workPanel.focusedWorkId);

  const openWork = useCallback(
    (workId: number) => dispatch(openPanel(workId)),
    [dispatch]
  );

  const closeWork = useCallback(
    (workId: number) => dispatch(closePanel(workId)),
    [dispatch]
  );

  const toggleWork = useCallback(
    (workId: number) => dispatch(toggleMinimize(workId)),
    [dispatch]
  );

  const focusWork = useCallback(
    (workId: number) => dispatch(focusPanel(workId)),
    [dispatch]
  );

  const closeAllWorks = useCallback(
    () => dispatch(closeAll()),
    [dispatch]
  );

  return {
    panels,
    focusedWorkId,
    openWork,
    closeWork,
    toggleWork,
    focusWork,
    closeAllWorks,
  };
};
